<template>
<div>
    <div class="pc">
        <div class="right-bg"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-header"><p>展厅导览</p></div>
            <div class="main" :style="{height:pageHeight}">
                <div class="main-list">
                    <div class="main-list-one">
                        <div class="main-title"><p>{{info.title}}</p>
                            <div class="main-collection" @click="collectHall()" :class="{'main-collection-active':isCollect}"><!-- 未收藏 collection-active收藏-->
                                <div class="collection-one" v-if="!isCollect"><img src="@/assets/newImages/personal/icon-img1.png" alt=""><span>收藏</span></div>
                                <div class="collection-one" v-if="isCollect"><img src="@/assets/newImages/personal/icon-img.png" alt=""><span>已收藏</span></div>
                            </div>
                        </div>
                        <div class="main-imgPage">
                            <div class="imgPage-left" :class="imgPageIndex<=0?'':'imgPage-left-active'" @click="reduceNum()">
                                <img src="@/assets/newImages/exhibitionGuide/left.png" alt="">
                                <img src="@/assets/newImages/exhibitionGuide/red-right.png" alt="">
                            </div>
                            <div class="imgPage-center">
                                <div class="imgPage-list" v-for="(imgPageOne, key) in imgPage" :key="key" :class="{'imgPage-list-active':imgPageIndex == key , 'imgPage-list-oldActive':imgPageIndex-1 == key}" >
                                    <div class="imgPage-one" v-for="(imgOne, key) in imgPageOne" :key="key" @click="clickIntro()"><img :src="imgOne" alt=""></div>
                                </div>
                            </div>
                            <div class="imgPage-right" :class="imgPageIndex>=imgPage.length-1?'':'imgPage-right-active'" @click="addNum()">
                                <img src="@/assets/newImages/exhibitionGuide/left.png" alt="">
                                <img src="@/assets/newImages/exhibitionGuide/red-right.png" alt="">
                            </div>
                        </div>
                        <!--<div class="text">{{info.content}}</div>-->
                        <div class="text" v-html="info.content"></div>
                        <div class="main-one" v-if="info.tags&&info.tags.length>0">
                            <div class="main-one-title">
                                <div class="left-line"></div>
                                <p>展示内容</p>
                            </div>
                            <div class="main-one-content">
                                <div class="main-two-content">
                                    <div class="main-one-two" v-for="(one, index) in info.tags" :key="index" >
                                        <p class="title" @click="clickSolution(one)">{{one}}</p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="main-one" v-if="info.fileList&&info.fileList.length>0">
                            <div class="main-one-title">
                                <div class="left-line"></div>
                                <p>展区资料</p>
                            </div>
                            <div class="main-one-content">
                                <div class="main-one-one" v-for="(file, index) in info.fileList" :key="index" >
                                    <div class="img1"><img src="@/assets/newImages/exhibitionGuide/main-one-img1.png" alt=""></div>
                                    <div class="text"><p>{{file.name}}</p></div>
                                    <div class="img2" @click="preview(file)"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""></div>
                                    <div class="img3" @click="download(file)"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="main-one" v-if="info.partner&&info.partner.length>0">
                            <div class="main-one-title">
                                <div class="left-line"></div>
                                <p>联合展示合作伙伴</p>
                            </div>    
                            <div class="main-one-content">
                                <div class="main-one-three" v-for="(one, index) in info.partner" :key="index"  @click="clickPartner(one)">
                                    <div class="img"><img :src="one.coverImageRealPath" alt=""></div>
                                    <div class="text-div">
                                        <p class="title">{{one.title}}</p>
                                        <p class="p">{{one.summary}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
    <div class="wap">
        <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-header"><p>展厅导览</p></div>
            <div class="con-main">
                <div class="main-list">
                    <div class="main-list-one">
                        <div class="main-title"><p>{{info.title}}</p>
                            <div class="main-collection" @click="collectHall()" :class="{'main-collection-active':isCollect}"><!-- 未收藏 collection-active收藏-->
                                <div class="collection-one" v-if="!isCollect"><img src="@/assets/newImages/personal/icon-img1.png" alt=""></div>
                                <div class="collection-one" v-if="isCollect"><img src="@/assets/newImages/personal/icon-img.png" alt=""></div>
                            </div>
                        </div>
                        <div class="main-imgPage">
                            <div class="imgPage-left" :class="imgPageIndex<=0?'':'imgPage-left-active'" @click="reduceNum()">
                                <img src="@/assets/newImages/exhibitionGuide/left.png" alt="">
                                <img src="@/assets/newImages/exhibitionGuide/red-right.png" alt="">
                            </div>
                            <!-- 使用同一个数组，wap变成一个为一组 -->
                            <div class="imgPage-center">
                                <div class="imgPage-list" v-for="(imageArr, key) in imgPage" :key="key" :class="{'imgPage-list-active':imgPageIndex == key , 'imgPage-list-oldActive':imgPageIndex-1 == key}" >
                                    <div class="imgPage-one" v-for="(imgOne, key) in imageArr" :key="key" @click="clickIntro"><img :src="imgOne" alt=""></div>
                                </div>
                            </div>
                            <div class="imgPage-right" :class="imgPageIndex>=imgPage.length-1?'':'imgPage-right-active'" @click="addNum()">
                                <img src="@/assets/newImages/exhibitionGuide/left.png" alt="">
                                <img src="@/assets/newImages/exhibitionGuide/red-right.png" alt="">
                            </div>
                        </div>
                        <!--<div class="text">{{info.content}}</div>-->
                        <div class="text" v-html="info.content"></div>
                        <div class="main-one" v-if="info.tags&&info.tags.length>0">
                            <div class="main-one-title"><div class="left-line"></div><p>展示内容</p></div>
                            <div class="two">
                                <div class="main-two-content">
                                    <div class="two-main " v-for="(one, index) in info.tags" :key="index" >
                                        <p class="title" @click="clickSolution(one)">{{one}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="main-one" v-if="info.fileList&&info.fileList.length>0">
                            <div class="main-one-title"><div class="left-line"></div><p>展区资料</p></div>
                            <div class="main-one-content">
                                <div class="main-one-one" v-for="(file, index) in info.fileList" :key="index" >
                                    <div class="img1-text">
                                        <div class="img1"><img src="@/assets/newImages/exhibitionGuide/main-one-img1.png" alt=""></div>
                                        <div class="text"><p>{{file.name}}</p></div>
                                    </div>
                                    <div class="imgs">
                                        <div class="img2" @click="preview(file)"><img src="@/assets/newImages/exhibitionGuide/main-one-img3.png" alt=""><span>在线预览</span></div>
                                        <div class="img3" @click="download(file)"><img src="@/assets/newImages/exhibitionGuide/main-one-img2.png" alt=""><span>资料下载</span></div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="main-one" v-if="info.partner&&info.partner.length>0">
                        <div class="main-one-title"><div class="left-line"></div><p>联合展示合作伙伴</p></div>
                            <div class="main-one-content">
                                <div class="main-one-three" v-for="(article, index) in info.partner" :key="index" @click="clickPartner(article)">
                                    <div class="img"><img :src="article.coverImageRealPath" alt=""></div>
                                    <div class="text-div">
                                        <p class="title">{{article.title}}</p>
                                        <p class="p">{{article.summary}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <registerPop :registerPop="registerPop" @registerPopClose="registerPopClose" @goRegister="goRegister"></registerPop>
    <downloadFilePop :downloadFilePop="downloadFilePop" :downloadFilePopMsg="downloadFilePopMsg" @closeDownLoadPop="closeDownLoadPop" @sendEmail="sendEmail"></downloadFilePop>
    <downloadFileSuccessPop :downloadFileSuccessPop="downloadFileSuccessPop" @downloadFilePopClose="downloadFilePopClose"></downloadFileSuccessPop>
</div>
    
</template>
<script>
import api from '../api';
import { stripHtmlTags, constructData, previewFile, goSignup } from '@/utils/tool';
import registerPop from 'components/registerPop';
import downloadFilePop from 'components/downloadFilePop';
import downloadFileSuccessPop from 'components/downloadFileSuccessPop';
export default {
        name: "exhibitionGuide",
        data(){
            return{
                pageHeight:'',
                height:document.documentElement.clientHeight,
                width:document.documentElement.clientWidth,
                imgPage:[],
                imgPageIndex:0,
                mainOne:[],
                showPop:false,
                isShow:true,
                info: {},
                registerPop: false,
                downloadFilePop: false,
                downloadFileSuccessPop: false,
                email: '',
                downloadFileId: '',
                downloadFilePopMsg: '',
                isCollect: false,
                myCollectList: [],
                m_industry_tag: '',
                m_product_tag: '',
                id: 0,
                zipNames: '',
                isRequest: false,
            }
        },
        components:{registerPop,downloadFilePop,downloadFileSuccessPop},
        created(){
            this.showHeight();
            this.getDetail();
            this.getMyCollectHall();
        },
        computed:{
            showNavDownload(){
                return this.$store.state.showControl.showNavDownload;
            },
        },
        methods: {
            currentIndex(){
                this.isShow=!this.isShow
            },
            // 内容有效区域高度
            showHeight(){
                this.pageHeight = this.height-100/1920*this.width-150/1920*this.width+"px"
            },
            reduceNum(){
                let self = this;
                if(self.imgPageIndex>0){
                    self.imgPageIndex = self.imgPageIndex-1
                }else{
                    self.imgPageIndex=0
                }
                this.clickIntro();
            },
            addNum(){
                let self = this;
                if(self.imgPageIndex<self.imgPage.length-1){
                    self.imgPageIndex =self.imgPageIndex+1
                }else{
                    self.imgPageIndex=self.imgPage.length-1
                }
                this.clickIntro();
            },
            showLoad(){
                this.showPop=true;
            },
            getDetail(){
                let id = this.$route.query.id;
                if(!id){
                    return;
                }else{
                    this.id = this.$route.query.id;
                    this.getTags();
                }

                let that = this;
                api.getExthallDetail(id)
                .then(res=>{
                    if(res){
                        if(!res.content){
                            that.getBanner(res.id);
                        }
                        // if(res.fileList.length==0 && res.fileIdsArr.length>0){
                        if(res.fileList.length==0 && res.fileFolderId && res.fileFolderId != 0){
                            that.getFiles(res.fileFolderId);
                        }
                        if(res.banner.length > 0){
                            if(that.$store.state.isPc){
                                that.imgPage = constructData(res.banner, 2);
                            }else{
                                that.imgPage = constructData(res.banner, 1);
                            }
                        }
                        this.info = res;
                        if(this.myCollectList.length>0){
                            let myData = this.myCollectList;
                            myData.map(item=>{
                                if(item.objectId == res.articleCategoryId){
                                    that.isCollect = true;
                                }
                            });
                        }
                    }
                })
                .catch(err=>{
                });
            },
            getBanner(id){
                let that = this;
                api.getExthallDetail2(id)
                .then(res=>{
                    if(res.result == 0){
                        let data = this.info;
                        data.content = res.content.content2;
                        that.info = data;
                        if(that.$store.state.isPc){
                            that.imgPage = constructData(res.content.showImagesRealPath, 2);
                        }else{
                            that.imgPage = constructData(res.content.showImagesRealPath, 1);
                        }
                    }
                })
                .catch(err=>{
                });

            },
            getFiles(folderId, idArr=[]){
                let that = this;
                api.getFileFolder(folderId, idArr)
                .then(res=>{
                    if(res.length > 0){
                        that.info.fileList = res;
                        let temp = [];
                        res.map(item=>{
                            temp.push(item.name);
                        });
                        that.zipNames = temp.join('^');
                    }
                })
                .catch(err=>{
                });

            },
            preview(file){
                // if(!this.$store.state.userLogin){
                //     this.showRegister();
                //     return;
                // }else{
                //     previewFile(file.fileUrl);
                //     return;
                // }

                // 埋码
                this.$maima.exhibition_page_onlinereview_click(this.info.title, file.name, this.m_product_tag, this.m_industry_tag);

                if(file.ext == 'temp'){
                    return;
                }

                previewFile(file.fileUrl);
                return;
            },
            download(file){
                if(!this.$store.state.userLogin){
                    this.showRegister();
                    return;
                }

                // 埋码
                this.$maima.exhibition_page_download_click(this.info.title, file.name, this.m_product_tag, this.m_industry_tag);

                if(file.ext == 'temp'){
                    return;
                }else{
                    this.downloadFileId = file.fileId;
                    this.showDownloadPop();
                    return;
                }
            },
            showRegister(){
                this.registerPop = true;
            },
            registerPopClose(){
                this.registerPop = false;
            },
            goRegister(){
                goSignup('online', this.$route.query.shareKey, true);
            },
            showDownloadPop(){
                this.downloadFilePop = true;
                this.email = this.$store.state.myData.email;
            },
            closeDownLoadPop(){
                this.downloadFilePop = false;
                this.downloadFilePopMsg = '';
            },
            sendEmail(email){
                let that = this;
                api.downloadWithEmail({
                    fileList: [that.downloadFileId],
                    email: email
                }).then(res=>{
                    if(res.result == 0){
                        that.downloadFilePop = false;
                        that.showDownloadFileSuccess();
                        that.downloadFileId = '';
                    }else{
                        that.downloadFilePopMsg = res.desc;
                    }
                })
                .catch(err=>{
                    that.$store.commit('showGlobalToast', {status: true, time: 6000, msg: '当前网络较差，建议更换网络环境并重新载入。'});
                });
            },
            showDownloadFileSuccess(){
                this.downloadFileSuccessPop = true;
            },
            getMyCollectHall(){
                if(!this.$store.state.userLogin){
                    return;
                }

                let that = this;
                api.myCollectExthall()
                .then(res=>{
                    if(res.result == 0){
                        that.myCollectList = res.content;
                        if(that.info.articleCategoryId){
                            res.content.map(item=>{
                                if(item.objectId == that.info.articleCategoryId){
                                    that.isCollect = true;
                                }
                            });
                        }
                    }
                })
                .catch(err=>{
                });
            },
            collectHall(){
                if(!this.$store.state.userLogin){
                    this.showRegister();
                    return;
                }else if(this.isCollect){
                    this.cancelHall();
                }else{

                    if(this.isRequest){
                        return;
                    }

                    this.isRequest = true;
                    let that = this;
                    api.collectExthall(that.info.articleCategoryId, that.info.title)
                    .then(res=>{
                        if(res.result == 0){
                            that.isCollect = true;
                            that.$store.commit('showCollectionSuccessToast', true);
                        }
                        that.isRequest = false;
                    })
                    .catch(err=>{
                        that.isRequest = false;
                    });
                }
            },
            cancelHall(){
                if(this.isRequest){
                    return;
                }

                this.isRequest = true;
                let that = this;
                api.cancelCollectExthall(''+that.info.articleCategoryId+'', that.info.title)
                .then(res=>{
                    if(res.result == 0){
                        that.isCollect = false;
                        that.$store.commit('showCollectionCancelToast', true);
                    }
                    that.isRequest = false;
                })
                .catch(err=>{
                    that.isRequest = false;
                });
            },
            downloadFilePopClose(){
                this.downloadFileSuccessPop = false;
            },
            getTags(){
                let that = this;
                api.getExthallList()
                .then(res=>{
                    res.map(pItem=>{
                        pItem.child.map(item=>{
                            if(item.articleCategoryId == that.id){
                                that.m_industry_tag = item.m_industry_tag;
                                that.m_product_tag = item.m_product_tag;
                            }
                        })
                    });
                })
                .catch(err=>{
                });
            },
            clickIntro(){
                // 埋码
                this.$maima.exhibition_page_introduction_click(this.info.title, this.zipNames, this.m_product_tag, this.m_industry_tag);
            },
            clickSolution(name){
                // 埋码
                this.$maima.exhibition_page_solution_click(this.info.title, name, this.m_product_tag, this.m_industry_tag);
            },
            clickPartner(item){
                // 埋码
                this.$maima.exhibition_page_partner_click(this.info.title, item.title);
            },
        },
    }   
</script>

<style scoped lang="scss">
*{
    box-sizing: border-box ;
    padding: 0;
    margin: 0;
}
.flex{
    display: flex;
}
.pc{
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: url('../assets/newImages/common/common-bg.png') no-repeat center center/cover;
    .right-bg{
        position: absolute;
        bottom: 0;
        right: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: 100%;
        }
    }
    .content{
        width: pxToVw(1600);
        margin-left: pxToVw(233);//87
        padding-top: pxToVw(49);
        .con-header{
            width: 100%;
            height: pxToVw(115);
            margin-bottom: pxToVw(21);
            p{  
                width: pxToVw(351);
                height: pxToVw(115);
                padding: pxToVw(39) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
        }
        .main{
            width: 100%;
            width: pxToVw(1540);
            margin-left: pxToVw(60);
            padding-right: pxToVw(20);
            .main-list{
                width: 100%;
                height: 100%;
                position: relative;
                background: rgba(255, 255, 255, 0.9);
                padding: pxToVw(20) 0;
                box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(3);
                .main-list-one{
                    position: relative;
                    width: pxToVw(1540);
                    height: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    padding: pxToVw(20) 0 pxToVw(28) pxToVw(50);
                    overflow-y: scroll;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    &::-webkit-scrollbar{
                        width: 3px;
                        height: 100%;
                        background: none;
                    }
                    &::-webkit-scrollbar-track{
                        background: none;
                    }
                    &::-webkit-scrollbar-thumb{
                        background: rgba(221, 221, 221, 0.6);
                    }
                    .main-title{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: pxToVw(1430);
                        p{
                            font-size: pxToVw(29);
                            color: #333333;
                            font-family: "FZLT-blackLittle";
                            line-height: pxToVw(35);
                        }
                        .main-collection{
                            width: pxToVw(136);
                            height: pxToVw(37);
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            .collection-one{
                                width: pxToVw(136);
                                height: pxToVw(37);
                                border-radius: pxToVw(20);
                                border: 1px solid #DDDDDD;
                                padding-left: pxToVw(21);
                                display: flex;
                                align-items: center;
                                &:nth-child(2){
                                    // display: none;
                                    border: 1px solid #C50819;
                                    span{
                                        color: #C50819;
                                    }
                                }
                                img{
                                    vertical-align: top;
                                    width: pxToVw(27);
                                    height: pxToVw(24);
                                    margin-top: pxToVw(-1);
                                    margin-right: pxToVw(10);
                                }
                                span{
                                    font-size: pxToVw(19);
                                    color: #999999;
                                    
                                    line-height: pxToVw(37);
                                }
                            }
                        }
                        // .collection-active{
                        //     .collection-one{
                        //         display: none;
                        //         &:nth-child(2){display: flex;}
                        //     }
                        // }
                    }
                    .main-imgPage{
                        margin: pxToVw(25) 0 pxToVw(31);
                        width: pxToVw(1428);
                        height: pxToVw(357);
                        display: flex;
                        .imgPage-left{
                            width: pxToVw(43);
                            height: pxToVw(357);
                            margin-right: pxToVw(23);
                            padding-top: pxToVw(163);
                            cursor: pointer;
                            img{
                                vertical-align: top;
                                width: pxToVw(43);
                                height: pxToVw(31);
                                &:nth-child(2){
                                    display: none;
                                    transform: rotate(180deg);
                                }
                            }
                        }
                        .imgPage-left-active{
                            img{
                                display: none;
                                &:nth-child(2){
                                    display: block;
                                }
                            }
                        }
                        .imgPage-right{
                            width: pxToVw(41);
                            height: pxToVw(357);
                            margin-left: pxToVw(22);
                            cursor: pointer;
                            padding-top: pxToVw(163);
                            img{
                                vertical-align: top;
                                width: pxToVw(41);
                                height: pxToVw(31);
                                transform: rotate(180deg);
                                &:nth-child(2){
                                    display: none;
                                    transform: rotate(0);
                                }
                            }
                        }
                        .imgPage-right-active{
                            img{
                                display: none;
                                &:nth-child(2){
                                    display: block;
                                }
                            }
                        }
                        .imgPage-center{
                            width: pxToVw(1299);
                            height: pxToVw(357);
                            position: relative;
                            overflow: hidden;
                            .imgPage-list{
                                position: absolute;
                                top: 0;
                                left: 0;
                                height: pxToVw(357);
                                width: pxToVw(1299);
                                display: flex;
                                opacity: 0;
                                transform: translateX(100%);
                                transition: all ease-in-out 0.3s;
                                .imgPage-one{
                                    height: pxToVw(357);
                                    width: pxToVw(636);
                                    margin-right: pxToVw(27);
                                    img{
                                        vertical-align: top;
                                        height: pxToVw(357);
                                        width: pxToVw(636);
                                    }
                                    &:nth-child(2){
                                        margin-right: 0;
                                    }
                                }
                            }
                            .imgPage-list-active{
                                opacity: 1;
                                transform: translateX(0);
                                transition: all ease-in-out 0.3s;
                            }
                            .imgPage-list-oldActive{
                                transform: translateX(-100%);
                                transition: all ease-in-out 0.3s;
                            }
                        }
                    }
                    .text{
                        width: pxToVw(1420);
                        font-size: pxToVw(19);
                        color: #999999;
                        line-height: pxToVw(29);
                    }
                    .main-one{
                        width: pxToVw(1405);
                        margin-top: pxToVw(28);
                        .main-one-title{
                            width: 100%;
                            display: flex;
                            height: pxToVw(24);
                            align-items: center;
                            margin-bottom: pxToVw(20);
                            .left-line{
                                width: pxToVw(4);
                                height: pxToVw(21);
                                background: #C50819;
                                border-radius: pxToVw(3);
                                margin-right: pxToVw(11);
                            }
                            p{
                                font-size: pxToVw(24);
                                font-family: "FZLT-blackLittle";
                                color: #333333;
                                line-height: pxToVw(28);
                            }
                        }
                        .main-one-content{
                            width: 100%;
                            display: flex;
                            flex-wrap: wrap;
                            .main-one-one{
                                margin: 0 pxToVw(27) pxToVw(27) 0 ;
                                width: pxToVw(688);
                                height: pxToVw(120);
                                display: flex;
                                background: #FFFFFF;
                                padding: pxToVw(25) pxToVw(35) 0 pxToVw(39);
                                box-shadow: 0px 0px pxToVw(11) 0px rgba(235,235,235,0.5);
                                border-radius: 0px 0px pxToVw(3) pxToVw(3);
                                &:nth-child(2n){
                                    margin-right: 0;
                                }
                                .img1{
                                    margin: pxToVw(7) pxToVw(21) 0 0;
                                    width: pxToVw(35);
                                    height: pxToVw(28);
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                                .text{
                                    width: pxToVw(413);
                                    height: pxToVw(64);
                                    font-size: pxToVw(19);
                                    color: #333333;
                                    line-height: pxToVw(32);
                                    overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                }
                                .img2{
                                    margin: 0 0 0 pxToVw(71);
                                    padding-top: pxToVw(4);
                                    width: pxToVw(28);
                                    height: pxToVw(31);
                                    cursor: pointer;
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                                .img3{
                                    margin: 0 0 0 pxToVw(21);
                                    padding-top: pxToVw(4);
                                    width: pxToVw(32);
                                    height: pxToVw(31);
                                    cursor: pointer;
                                    img{
                                        width: 100%;
                                        vertical-align: top;
                                    }
                                }
                            }
                            .main-two-content{
                                width: pxToVw(1422);
                                margin-left: pxToVw(-9);
                                margin-right: pxToVw(-8);
                                display: flex;
                                flex-wrap: wrap;
                                .main-one-two{
                                    width: pxToVw(333);
                                    height: pxToVw(83);
                                    padding: 0 pxToVw(20);
                                    margin: pxToVw(0) pxToVw(29) pxToVw(11) 0;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    background: url('../assets/newImages/exhibitionGuide/content-bg.png')no-repeat center center/cover;
                                    &:nth-child(4n){
                                        margin-right: 0;
                                    }
                                    p{
                                        font-size: pxToVw(19);
                                        font-weight: normal;
                                        color: #333333;
                                        line-height: pxToVw(32);
                                    }
                                    
                                }
                            }
                            
                            .main-one-three{
                                margin: pxToVw(10) 0 pxToVw(17);
                                width: pxToVw(1405);
                                height: pxToVw(109);
                                display: flex;
                                background: #FFFFFF;
                                box-shadow: 0px 0px pxToVw(13) 0px rgba(229,229,229,0.5);
                                border-radius: pxToVw(3);
                                .img{
                                    width: pxToVw(219);
                                    height: pxToVw(109);
                                    img{
                                        vertical-align: top;
                                        width: 100%;
                                    }
                                }
                                .text-div{
                                    width: pxToVw(1186);
                                    height: pxToVw(109);
                                    padding: pxToVw(19) pxToVw(40) 0 pxToVw(32);
                                    border-left: 1px solid #EEEEE0;
                                    .title{
                                        font-size: pxToVw(19);
                                        color: #333333;
                                        line-height: pxToVw(23);
                                        overflow: hidden;
                                        text-overflow :ellipsis; 
                                        white-space: nowrap; 
                                    }
                                    .p{
                                        height: pxToVw(50);
                                        font-size: pxToVw(16);
                                        color: #999999;
                                        line-height: pxToVw(24);
                                        overflow: hidden;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        text-overflow :ellipsis; 
                                    }
                                }
                            }
                        }
                    }

                }
            }
        }
    }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 13.3vw;
        background: url('../assets/newImages/exhibitionGuide/wap-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .content{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .con-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .con-main{
                width: 90.9vw;
                margin: 2.3vw auto 0;
                // padding-right: pxToVw(20);
                .main-list{
                    width: 100%;
                    height: 100%;
                    position: relative;
                    background: RGBA(247, 248, 250, .71);
                    box-shadow: 0px 0px 2.7vw 0px rgba(231,231,231,0.5);
                    border-radius: 0.3vw;
                    padding: 6.8vw 3.5vw 10.9vw;
                    .main-list-one{
                        position: relative;
                        // width: 90.9vw;
                        height: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        // padding: pxToVw(20) 0 pxToVw(28) pxToVw(50);
                        // overflow-y: scroll;
                        // scrollbar-width: none;
                        // -ms-overflow-style: none;
                        // &::-webkit-scrollbar{
                        //     width: 3px;
                        //     height: 100%;
                        //     background: none;
                        // }
                        // &::-webkit-scrollbar-track{
                        //     background: none;
                        // }
                        // &::-webkit-scrollbar-thumb{
                        //     background: rgba(221, 221, 221, 0.6);
                        // }
                        .main-title{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 83.9vw;
                            padding-left: 1.3vw;
                            p{
                                font-size: 4.3vw;
                                color: #333333;
                                font-family: "FZLT-blackLittle";
                                line-height: 5.1vw;
                            }
                            .main-collection{
                                width: 4vw;
                                height: 3.6vw;
                                .collection-one{
                                    width: 4vw;
                                    height: 3.6vw;
                                    // border-radius: pxToVw(20);
                                    // border: 1px solid #DDDDDD;
                                    // padding-left: pxToVw(21);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    // &:nth-child(2){
                                    //     // display: none;
                                    //     border: 1px solid #C50819;
                                    //     span{
                                    //         color: #C50819;
                                    //     }
                                    // }
                                    img{
                                        vertical-align: top;
                                        width: 4vw;
                                        height: 3.6vw;
                                        // margin-right: pxToVw(10);
                                    }
                                    // span{
                                    //     font-size: pxToVw(19);
                                    //     color: #999999;
                                    //     line-height: pxToVw(23);
                                    // }
                                }
                            }
                            // .collection-active{
                            //     .collection-one{
                            //         display: none;
                            //         &:nth-child(2){display: flex;}
                            //     }
                            // }
                        }
                        .main-imgPage{
                            margin: 7.3vw 0 4.1vw;
                            width: 82.7vw;
                            height: 39.5vw;
                            display: flex;
                            .imgPage-left{
                                width: 4.1vw;
                                height: 39.5vw;
                                margin-right: 2.5vw;
                                padding-top: 18.5vw;
                                img{
                                    vertical-align: top;
                                    width: 4.1vw;
                                    height: 3.1vw;
                                    &:nth-child(2){
                                        display: none;
                                        transform: rotate(180deg);
                                    }
                                }
                            }
                            .imgPage-left-active{
                                img{
                                    display: none;
                                    &:nth-child(2){
                                        display: block;
                                    }
                                }
                            }
                            .imgPage-right{
                                width: 4.1vw;
                                height: 39.5vw;
                                margin-left: 2.5vw;
                                padding-top: 18.5vw;
                                img{
                                    vertical-align: top;
                                    width: 4.1vw;
                                    height: 3.1vw;
                                    transform: rotate(180deg);
                                    &:nth-child(2){
                                        display: none;
                                        transform: rotate(0);
                                    }
                                }
                            }
                            .imgPage-right-active{
                                img{
                                    display: none;
                                    &:nth-child(2){
                                        display: block;
                                    }
                                }
                            }
                            .imgPage-center{
                                width: 69.5vw;
                                height: 39.5vw;
                                position: relative;
                                overflow: hidden;
                                .imgPage-list{
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 70.3vw;
                                    height: 39.5vw;
                                    display: flex;
                                    opacity: 0;
                                    transform: translateX(100%);
                                    transition: all ease-in-out 0.3s;
                                    .imgPage-one{
                                        width: 70.3vw;
                                        height: 39.5vw;
                                        // margin-right: pxToVw(27);
                                        img{
                                            vertical-align: top;
                                            width: 69.5vw;
                                            height: 39.5vw;
                                        }
                                        // &:nth-child(2){
                                        //     margin-right: 0;
                                        // }
                                    }
                                }
                                .imgPage-list-active{
                                    opacity: 1;
                                    transform: translateX(0);
                                    transition: all ease-in-out 0.3s;
                                }
                                .imgPage-list-oldActive{
                                    transform: translateX(-100%);
                                    transition: all ease-in-out 0.3s;
                                }
                            }
                        }
                        .text{
                            width: 83.5vw;
                            font-size: 3.2vw;
                            color: #999999;
                            line-height: 4.8vw;
                        }
                        .main-one{
                            width: 83.7vw;
                            margin-top: 6.7vw;
                            .main-one-title{
                                width: 100%;
                                display: flex;
                                height: 4vw;
                                align-items: center;
                                margin-bottom: 2.7vw;
                                .left-line{
                                    width: 0.6vw;
                                    height: 3vw;
                                    background: #C50819;
                                    border-radius: 0.4vw;
                                    margin-right: 1.5vw;
                                }
                                p{
                                    font-size: 3.5vw;
                                    font-family: "FZLT-blackLittle";
                                    color: #333333;
                                    line-height: 4vw;
                                }
                            }
                            .main-one-content{
                                width: 100%;
                                display: flex;
                                // flex-wrap: wrap;
                                flex-direction: column;
                                .main-one-one{
                                    margin: 0 0 2.7vw 0 ;
                                    width: 83.7vw;
                                    height: 24vw;
                                    // display: flex;
                                    background: #FFFFFF;
                                    padding: 3.3vw 3.6vw 0;
                                    box-shadow: 0px 0px 1.1vw 0px rgba(235,235,235,0.5);
                                    border-radius: 0px 0px 0.3vw 0.3vw;
                                    // &:nth-child(2n){
                                    //     margin-right: 0;
                                    // }
                                    .img1-text{
                                        display: flex;
                                        .img1{
                                            margin: 0 4.7vw 0 0;
                                            width: 5.2vw;
                                            height: 4.1vw;
                                            img{
                                                width: 100%;
                                                vertical-align: top;
                                            }
                                        }
                                        .text{
                                            width: 64.8vw;
                                            height: 9.6vw;
                                            font-size: 3.5vw;
                                            color: #333333;
                                            line-height: 4.8vw;
                                            overflow: hidden;
                                            display: -webkit-box;
                                            -webkit-line-clamp: 2;
                                            -webkit-box-orient: vertical;
                                        }
                                    }
                                    .imgs{
                                        display: flex;
                                        margin: 3.2vw 0 0 10vw;
                                        span{
                                            font-size: 3.2vw;
                                            line-height: 3.6vw;
                                            margin-left: 2vw;
                                            font-weight: normal;
                                            color: #666666;
                                        }
                                        .img2{
                                            // padding-top: pxToVw(4);
                                            width: 20.3vw;
                                            // height: 3.2vw;
                                            display: flex;
                                            align-items: center;
                                            img{
                                                width: 3.1vw;
                                                height: 3.2vw;
                                                min-width: 3.1vw;
                                                vertical-align: top;
                                            }
                                        }
                                        .img3{
                                            margin: 0 0 0 1.2vw;
                                            // padding-top: pxToVw(4);
                                            width: 21.3vw;
                                            // height: 3.3vw;
                                            display: flex;
                                            align-items: center;
                                            img{
                                                width: 4.1vw;
                                                height: 3.3vw;
                                                min-width: 4.1vw;
                                                vertical-align: top;
                                            }
                                        }
                                    }
                                    
                                }
                                
                                .main-one-three{
                                    margin: 0 0 2.7vw;
                                    width: 83.7vw;
                                    height: auto;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    background: #FFFFFF;
                                    box-shadow: 0px 0px 1.3vw 0px rgba(229,229,229,0.5);
                                    border-radius: 0.3vw;
                                    padding-top: 1.5vw;
                                    padding-bottom: 1.5vw;
                                    &:nth-child(1){
                                        margin-top: 3.2vw;
                                    }
                                    &:last-child{
                                        margin-bottom: 0;
                                    }
                                    .img{
                                        width: 21.9vw;
                                        height: 10.9vw;
                                        margin-bottom: 0.7vw;
                                        // margin: 0 auto;
                                        img{
                                            vertical-align: top;
                                            width: 100%;
                                        }
                                    }
                                    .text-div{
                                        width: 78.3vw;
                                        // height: 10.9vw;
                                        padding: 3.2vw 0 0 1.3vw;
                                        border-top: 1px solid #EEEEE0;
                                        .title{
                                            font-size: 3.5vw;
                                            color: #333333;
                                            line-height: 4vw;
                                            overflow: hidden;
                                            text-overflow :ellipsis; 
                                            white-space: nowrap; 
                                        }
                                        .p{
                                            // height: 17.6vw;
                                            font-size: 3.2vw;
                                            color: #999999;
                                            line-height: 4.8vw;
                                            // overflow: hidden;
                                            // display: -webkit-box;
                                            // -webkit-line-clamp: 3;
                                            // -webkit-box-orient: vertical;
                                            // text-overflow :ellipsis; 
                                            margin-top: 2vw;
                                        }
                                    }
                                }
                                
                            }
                            .two{
                                width: 83.5vw;
                                height: auto;
                                display: flex;
                                flex-wrap: wrap;
                                margin: 0 auto;
                                .main-two-content{
                                    display: flex;
                                    flex-wrap: wrap;
                                    .two-main{
                                        width: 40.3vw;
                                        height: 12vw;
                                        margin: 0 2.9vw 2.7vw 0; 
                                        padding: 0 3vw;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                        background: url('../assets/newImages/exhibitionGuide/content-bg.png')no-repeat center center/cover;  
                                        &:nth-child(2n){
                                            margin-right: 0;
                                        }
                                        p{
                                            font-size:3.2vw;
                                            font-weight: normal;
                                            color: #333333;
                                            line-height: 4.2vw;
                                        }
                                    }
                                }
                                
                            } 
                        }

                    }
                }
            }
        }
    }
}
</style>
 